import { FunctionComponent, useEffect, useState } from 'react';
import PaperLayout from '../layout/PaperLayout';
import { useApartments } from './apartmentService';
import ApartmentList from './components/ApartmentList';
import LocationList from './components/LocationList';
import { LocationResponse } from './models/GetApartmentsResponse';

const Apartments: FunctionComponent = () => {
    const { response, refetch } = useApartments();
    const [location, setLocation] = useState<LocationResponse | undefined>();

    useEffect(() => {
        if (response && location) {
            const refreshedLocation = response.locations.find((l) => l.locationId === location.locationId);
            setLocation(refreshedLocation);
        }
    }, [response]);

    if (!response) {
        return null;
    }

    return (
        <PaperLayout heading="Lägenheter" tightenUp={true}>
            {location ? <ApartmentList location={location} refreshApartments={refetch} setLocation={setLocation} /> : <LocationList locations={response.locations} setLocation={setLocation} />}
        </PaperLayout>
    );
};

export default Apartments;
